export default __webpack_public_path__ + "static/media/dietlyLoader.3385875a.gif";